export default "__VITE_ASSET__9ab5c7dc__"